import React, { useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import logo from "../../utils/images/success.png";
import { Context } from "../../../context/DataProvider";
import mailIcon from "../../utils/images/mailIcon.svg";
import { createPopup } from "@typeform/embed";
import "@typeform/embed/build/css/popup.css";
import { getCustomerSupportEmailId, USER_DETAILS_KEYS, HIDE_HELP_SECTION_ENTITY_IDS } from "../../../utils/constants";
import { Stack } from "@mui/material";
import { getUserDetails } from "../../utils/miscutils";
import { handleKeyboardClick } from "../../../utils/keyboardUtils";

const delay = (ms) => new Promise((res) => setTimeout(res, ms));
const spellOutId = (id) => String(id).split("").join(" ");
export default function SuccessClaim(props) {
  const navigate = useNavigate();
  const { setBankSelected } = useContext(Context);
  const id = "FU54QexI";
  const widget = createPopup(id);
  const successMsgRef = useRef(null);

  const openFeedBackForm = async () => {
    await delay(300);
    widget.open();
  };

  const goTo = () => {
    navigate("/reimbursements");
    setBankSelected(null);
  };
  useEffect(() => {
    if (successMsgRef.current) {
      successMsgRef.current.focus();
    }
    openFeedBackForm();
  }, []);
  return (
    <Stack
      spacing={{ md: 2, sm: 1 }}
      direction="column"
      useFlexGap
      sx={{
        marginTop: "2rem", // default value for larger screens
        "@media (max-width:600px)": {
          marginTop: "6rem", // override for mobile screens
        },
      }}
    >
      <Stack direction={"row-reverse"}>
        <CloseIcon
          role="button"
          aria-label="Close and go to reimbursements"
          tabIndex="0"
          onClick={() => goTo()}
          onKeyDown={handleKeyboardClick(goTo)}
          fontSize="large"
          sx={{ cursor: "pointer" }}
        />
      </Stack>
      <div>
        <img
          alt="logo"
          aria-hidden="true"
          src={logo}
          style={{
            display: "block",
            marginLeft: "auto",
            marginRight: "auto",
            height: "300px",
            marginTop: "100px",
          }}
        />
        <br></br>
        {props.message === "resubmitted" ? (
          <p
            ref={successMsgRef}
            tabIndex={-1}
            role="status"
            aria-live="polite"
            aria-atomic="true"
            aria-label={`Your Claim ${spellOutId(props.claimId)} has been resubmitted successfully`}
            style={{ textAlign: "center", fontSize: "24px", outline: "none" }}
          >
            Your Claim {props.claimId} has been resubmitted successfully
          </p>
        ) : (
          <p
            ref={successMsgRef}
            tabIndex={-1}
            role="status"
            aria-live="polite"
            aria-atomic="true"
            aria-label={`Your Claim ${spellOutId(props.claimId)} has been successfully Raised`}
            style={{ textAlign: "center", fontSize: "24px", outline: "none" }}
          >
            Your Claim {props.claimId} has been successfully Raised
          </p>
        )}
      </div>

      {!HIDE_HELP_SECTION_ENTITY_IDS.includes(parseInt(getUserDetails(USER_DETAILS_KEYS.PM_ENTITY_ID))) && (
        <div
          className="successPageQueries"
          role="complementary"
          aria-label="Claim support contact"
        >
          <div className="successPart1">
            <img src={mailIcon} alt="mailIcon" aria-hidden="true" />
            <b style={{ marginLeft: "10px" }}> Raise any claim related queries</b>
          </div>
          <div className="successPart2">
            <p>
              For speedy resolution to any doubts/concerns/queries related to your
              existing OPD claims, please write to our email id{" "}
              <strong>{getCustomerSupportEmailId()}</strong>. Our tech team will
              check at the earliest and get your issue resolved
            </p>
          </div>
        </div>
      )}
    </Stack>
  );
}
